export default {
  api_r_user_module_resourceManager_getModuleData: {
    path: 'm/resource-manager/get-module-data/',
  },
  api_r_user_module_resourceManager_getPermissions: {
    path: 'm/resource-manager/get-permissions/',
  },
  api_r_user_module_resourceManager_getNavbarInfo: {
    path: 'm/resource-manager/get-navbar-info/',
  },
  api_r_user_module_resourceManager_information_tab: {
    path: 'm/resource-manager/information/tab/',
  },
  api_r_user_module_resourceManager_resource_information_edit: {
    path: 'm/resource-manager/resource/information/edit/',
  },
  api_r_user_module_resourceManager_resource_information_archive: {
    path: 'm/resource-manager/resource/information/archive/',
  },
  api_r_user_module_resourceManager_resource_information_delete: {
    path: 'm/resource-manager/resource/information/delete/',
  },
  api_r_user_module_resourceManager_information_file_download: {
    path: 'm/resource-manager/information/file/download/',
  },
  api_r_user_module_resourceManager_resourceObligation_list: {
    path: 'm/resource-manager/resource-obligation/list/',
  },
  api_r_user_module_resourceManager_resourceObligation_level: {
    path: 'm/resource-manager/resource-obligation/level/',
  },
  api_r_user_module_resourceManager_resourceObligation_single: {
    path: 'm/resource-manager/resource-obligation/single/',
  },
  api_r_user_module_resourceManager_generateFilterHexCode: {
    path: 'm/resource-manager/generate-filter-hex-code/',
  },
  api_r_user_module_resourceManager_getFilters: {
    path: 'm/resource-manager/get-filters/',
  },
  api_r_user_module_resourceManager_getFiltersByFeatures: {
    path: 'm/resource-manager/get-filters-by-features/',
  },
  api_r_user_module_resourceManager_generateFilterHexCodeWithObligationIDs: {
    path: 'm/resource-manager/generate-filter-hex-code-with-obligation-ids/',
  },
  api_r_user_module_resourceManager_resource_image_set: {
    path: 'm/resource-manager/resource-image-set/',
  },
  api_r_user_module_resourceManager_resourceObligation_nextDate_set: {
    path: 'm/resource-manager/resource-obligation/next-date/set/',
  },
  api_r_user_module_resourceManager_resourceObligation_tab: {
    path: 'm/resource-manager/resource-obligation/tab/',
  },
  api_r_user_module_resourceManager_resourceObligation_update_getInternals: {
    path: 'm/resource-manager/resource-obligation/update/get-internals/',
  },
  api_r_user_module_resourceManager_resourceObligation_update: {
    path: 'm/resource-manager/resource-obligation/update/',
  },
  api_r_user_module_resourceManager_resourceObligation_prevision_update: {
    path: 'm/resource-manager/resource-obligation/prevision/update/',
  },
  api_r_user_module_resourceManager_resourceObligation_prevision_togglePeriodValidation:
    {
      path: 'm/resource-manager/resource-obligation/prevision/toggle-period-validation/',
    },
  api_r_user_module_resourceManager_resourceObligation_prevision_recalculate: {
    path: 'm/resource-manager/resource-obligation/prevision/recalculate/',
  },
  api_r_user_module_resourceManager_resourceObligation_prevision_reset: {
    path: 'm/resource-manager/resource-obligation/prevision/reset/',
  },
  api_r_user_module_resourceManager_resourceObligation_prevision_evidence_set: {
    path: 'm/resource-manager/resource-obligation/prevision/evidence/set/',
  },
  api_r_user_module_resourceManager_resourceObligation_prevision_evidence_delete:
    {
      path: 'm/resource-manager/resource-obligation/prevision/evidence/delete/',
    },
  api_r_user_module_resourceManager_resourceObligation_prevision_evidence_file_download:
    {
      path: 'm/resource-manager/resource-obligation/prevision/evidence/file/download/',
    },
  api_r_user_module_resourceManager_resourceObligation_prevision_evidenceForm_get:
    {
      path: 'm/resource-manager/resource-obligation/prevision/evidence-form/get/',
    },
  api_r_user_module_resourceManager_resourceObligation_massive_nextDate_set: {
    path: 'm/resource-manager/resource-obligation/massive/next-date/set/',
  },
  api_r_user_module_resourceManager_resourceObligation_massive_prevision_evidence_set:
    {
      path: 'm/resource-manager/resource-obligation/massive/prevision/evidence/set/',
    },
  api_r_user_module_resourceManager_responsible_list: {
    path: 'm/resource-manager/responsible/list/',
  },
  api_r_user_module_resourceManager_responsible_get: {
    path: 'm/resource-manager/responsible/get/',
  },
  api_r_user_module_resourceManager_responsible_edit: {
    path: 'm/resource-manager/responsible/edit/',
  },
  // Calendar
  api_r_user_module_resourceManager_calendar_prevision_list: {
    path: 'm/resource-manager/calendar/prevision/list/',
  },
  api_r_user_module_resourceManager_calendar_xls_download: {
    path: 'm/resource-manager/calendar/xls/download/',
  },
  // Settings
  api_r_user_module_resourceManager_settings_resourceTemplate_list: {
    path: 'm/resource-manager/settings/resource-template/list/',
  },
  api_r_user_module_resourceManager_settings_resourceTemplate_get: {
    path: 'm/resource-manager/settings/resource-template/get/',
  },
  api_r_user_module_resourceManager_settings_resourceTemplate_clone: {
    path: 'm/resource-manager/settings/resource-template/clone/',
  },
  api_r_user_module_resourceManager_settings_resourceTemplate_delete: {
    path: 'm/resource-manager/settings/resource-template/delete/',
  },
  api_r_user_module_resourceManager_settings_resource_add: {
    path: 'm/resource-manager/settings/resource/add/',
  },
  api_r_user_module_resourceManager_settings_resource_edit: {
    path: 'm/resource-manager/settings/resource/edit/',
  },
  api_r_user_module_resourceManager_settings_internalObligation_list: {
    path: 'm/resource-manager/settings/internal-obligation/list/',
  },
  api_r_user_module_resourceManager_settings_internalObligation_get: {
    path: 'm/resource-manager/settings/internal-obligation/get/',
  },
  api_r_user_module_resourceManager_settings_internalObligation_add: {
    path: 'm/resource-manager/settings/internal-obligation/add/',
  },
  api_r_user_module_resourceManager_settings_internalObligation_edit: {
    path: 'm/resource-manager/settings/internal-obligation/edit/',
  },
  api_r_user_module_resourceManager_getCategories: {
    path: 'm/resource-manager/get-categories/',
  },
  api_r_user_module_resourceManager_getResources: {
    path: 'm/resource-manager/get-resources/',
  },
  api_r_user_module_resourceManager_getPlants: {
    path: 'm/resource-manager/get-plants/',
  },
  // Reports
  api_r_user_module_resourceManager_xls_upload: {
    path: 'm/resource-manager/xls/upload/',
  },
  api_r_user_module_resourceManager_report_xls1: {
    path: 'm/resource-manager/report/xls1/',
  },
  api_r_user_module_resourceManager_report_xls2: {
    path: 'm/resource-manager/report/xls2/',
  },
  api_r_user_module_resourceManager_xls_download: {
    path: 'm/resource-manager/xls/download/',
  },
};
